module.exports = __webpack_public_path__ + "static/media/new_order.d13f1f23.mp3";